export const FETCH_GROUPS_COLLECTION = 'posts/FETCH_GROUPS_COLLECTION';
export const FETCH_GROUPS_COLLECTION_SUCCESS = 'posts/FETCH_GROUPS_COLLECTION_SUCCESS';